<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">View</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Transaction PAN"
            :data="editedItem"
            :valueData="editedItem.trx_pan"
            noGutters
          />
          <data-detail-row
            label="Invoice Number"
            :data="editedItem"
            :valueData="editedItem.invoice_number"
            noGutters
          />
          <data-detail-row
            label="Merchant Name"
            :data="editedItem"
            :valueData="editedItem.merchant_name"
            noGutters
          />
          <data-detail-row
            label="MID"
            :data="editedItem"
            :valueData="editedItem.mid"
            noGutters
          />
          <data-detail-row
            label="Merchant PAN"
            :data="editedItem"
            :valueData="editedItem.mpan"
            noGutters
          />
          <data-detail-row
            label="Reff ID"
            :data="editedItem"
            :valueData="editedItem.rrn"
            noGutters
          />
          <data-detail-row
            label="Transaction Type"
            :data="editedItem"
            :valueData="editedItem.trx_type"
            noGutters
          />
          <data-detail-row
            label="Issuer Name"
            :data="editedItem"
            :valueData="editedItem.issuer_name"
            noGutters
          />
          <data-detail-row
            label="Customer PAN"
            :data="editedItem"
            :valueData="editedItem.customer_pan"
            noGutters
          />
          <data-detail-row
            label="Payment Type"
            :data="editedItem"
            :valueData="editedItem.payment_type"
            noGutters
          />
          <data-detail-row
            label="Acquirer Name"
            :data="editedItem"
            :valueData="editedItem.payment_channel"
            noGutters
          />
          <data-detail-row
            label="Amount"
            :data="editedItem"
            :valueData="editedItem.amount"
            noGutters
          />
          <data-detail-row
            label="MDR"
            :data="editedItem"
            :valueData="editedItem.amount_mdr"
            noGutters
          />
          <data-detail-row
            label="Net Amount"
            :data="editedItem"
            :valueData="editedItem.net_amount"
            noGutters
          />
          <data-detail-row
            label="Transaction Date"
            :data="editedItem"
            :valueData="editedItem.trx_datetime"
            noGutters
          />
          <data-detail-row
            label="Status Transaksi"
            :data="editedItem"
            :valueData="editedItem.status"
            noGutters
          />
          <data-detail-row
            label="Settlement Status"
            :data="editedItem"
            :valueData="editedItem.settlement_status"
            noGutters
          />
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
export default {
  components: { DataDetailRow: () => import('../detail/DataDetailRow.vue') },
  props: ['editedItem'],
  computed: {},
  data: () => ({
    dialogMerchant: false,
  }),
  methods: {
    close() {
      this.$emit('closeParent');
    },
  },
};
</script>
